<template>
  <div class="items">
    <img v-if="report.has_warning" src="@assets/img/common/warnTag.svg" alt="warn" class="warning">
    <div class="item">
      <div class="pic" @click="playMedia(report)">
        <img @error="imgError(report)" class="main" :src="report.cover" alt="pic" v-if="report.cover">
        <img class="main" :src="report.has_sound?defaultAudioImg:defaultImg" alt="default" v-if="!report.cover">
        <img v-if="+report.play_icon === 1" class="play" src="@assets/img/index/play.svg" alt="play">
      </div>
      <div class="article">
        <div class="title" @click="goDetail(report)">
          <p class="words" v-html="report.title || report.username" :title="report.title || report.username">
      
          </p>
          <img src="@assets/img/common/tips.svg" alt="change" v-if="report.has_change - 0 === 1">
          <img src="@assets/img/common/new.svg" alt="new" v-if="report.is_new - 0 === 1">
          <img src="@assets/img/common/imgIcon.svg" alt="img" v-if="report.has_img - 0 === 1">
          <img src="@assets/img/common/videoIcon.svg" alt="video" v-if="report.has_video - 0 === 1">
          <img src="@assets/img/common/audioIcon.svg" alt="audio" v-if="report.has_sound - 0 === 1">
          <img alt="技审未通过" title="技审未通过" class="verify-logo" v-if="report.has_audit&&report.has_audit==2" src="@assets/img/common/verify-fail.svg">
        </div>
        <p v-html="report.content" class="content normal">
        </p>
        <div class="footline">
          <!-- 微信类型 todo-->
          <!-- <p class="mark platform wx" v-if="report.category==6||true">
              <img :src="report.avatar" alt="user">
              <span>{{report.source_info.ptitle}}</span>
            </p> -->
          <!-- 普通类型 v-else-->
          <p class="mark platform">
            <img src="@assets/img/common/xy.svg" alt="user">
            <span>{{report.source_info.ptitle}}</span>
          </p>
          <p class="mark">
            <img src="@assets/img/common/zz.svg" alt="time">
            <span :class="{'card': type == 2 || type == 3}" @click="showCard(report.uid, $event)">
              {{report.username}}
            </span>
          </p>
          <p class="mark">
            <img src="@assets/img/index/time.svg" alt="time">
            <span>{{report.release_time}}</span>
          </p>
          <p class="mark caiyong">
            <img src="@assets/img/index/beUse.svg" alt="tv">
            <span>
              {{`被采用 ${report.reports&&report.reports.length||0}`}}
              <div class="tips" v-if="report.reports&&report.reports.length > 0">
                <p v-for="(r, ri) in report.reports" class="tip" @click="goRptDtl(r)" :key="ri">
                  <img v-if="r.type == 'report'" src="@assets/img/common/reportIcon.svg">
                  <img v-if="r.type == 'publish'" src="@assets/img/common/uploadIcon.svg">
                  <img v-if="r.use_type == 'new_media'" src="@assets/img/common/uploadIcon.svg">
                  <i class="tiptitle">{{r.title}}</i>
                  <i class="tiper">{{r.user_name}}</i>
                  <i class="tiptime">{{r.raw_add_time}}</i>
                </p>
              </div>
            </span>
          </p>
        </div>
      </div>
      <div class="handles">
        <div v-if="report.has_report_role || report.has_publish || report.has_new_media" class="pushBtn">
          <p>
            <span>推送</span>
            <i></i>
          </p>
          <div class="btn">
            <span></span>
            <ul>
              <li v-if="report.has_report_role" @click="goReport(report,i)">{{`推送${$_syscfg.report}`}}</li>
              <li v-if="report.has_publish" @click="pushPublish(report.id, 'material', i)">{{`推送${$_syscfg.publish}`}}</li>
              <li v-if="report.has_new_media" @click="pushMedia(report, i)">{{`推新发布`}}</li>
            </ul>
          </div>
        </div>
        <div v-if="report.has_stream_send" class="threePoint">
          <i></i>
          <div class="btn">
            <span></span>
            <ul>
              <li @click="mediaSend(report.id)">{{`归档`}}</li>
            </ul>
          </div>
        </div>
        <!-- <div class="handle l" v-if="report.has_report_role" @click="goReport(report)">
          {{`推送${$_syscfg.report}`}}
        </div>
        <div class="handle l" v-if="report.has_publish" @click="pushPublish(report.id, 'material')">
          {{`推送${$_syscfg.publish}`}}
        </div>
        <div class="handle l" v-if="report.has_new_media" @click="pushMedia(report)">
          {{`推新发布`}}
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
//  3/1网站 2渠道 3自采 4收录 5微博 6微信 7广播音频 8融媒体视频 9外部稿库
import common from "@common/common";
import { apis } from "@common/config";
import vClickOutside from "v-click-outside";
export default {
  name: "baseItem",
  directives: {
    clickOutside: vClickOutside.directive
  },
  props: {
    report: {
      type: Object,
      required: true,
      default: () => ({})
    },
    type: {
      required: true,
      type: Number,
      // 2是线索，3是素材
      default: 2
    }
  },
  data() {
    return {
      defaultImg: require("@assets/img/common/default.png"),
      defaultAudioImg: require("@assets/img/common/audioMask.png"),
      isXnew: this.$store.state.isXnew,
    };
  },
  methods: {
    mediaSend(id) {
      let info = {
          subject_type: 0,
          subject_id: id
      };
      common
      .myFetch(apis.streamMediaSend, info)
      .then(r => {
          if (r) {
              this.$toast(r)
          }
      });
    },
    closePushBtns() {
      this.report.showPushBtns = false;
    },
    closeThreePoint() {
      this.report.showThreePoint = false;
    },
    async pushMedia(item) {
      console.log(item)
      const type = await this.$MediaPlatform('push');
      if (!type) return;
      console.log(type)
      let info = {
          platforms: type,
          submit_type: 0,
          subject_type: 0,
          subject_id: item.id
      };

      common
      .myFetch(apis.newMediaPlatformCreate, info)
      .then(r => {
          if (r) {
              console.log(r)
              common.jump(`/createMediaPublish?d=${r.report_id}`, true);
          }
      });
      // common.jump(`/createMediaPublish?d=${type}`, true);
    },
    async pushPublish(id, t) {
      // 推送发布
      const type = await this.$pageType("publish");
      if (!type) return;

      const info = {
        subject_id: id,
        subject_type: t,
        type: type
      };

      common.myFetch(apis.publish_pushPublish, info).then(r => {
        if (r) {
          const url = `/editPublish?d=${r.id}`;

          common.jump(url, true);
        }
      });
    },
    showCard(id, e) {
      if (id == 0) return;

      const el = e.target;

      this.$card(id, el);
    },
    showIncludes() {
      // 显示收录单弹窗
      this.$refs.includeClues.open();
    },
    playMedia({ sound_list, img_list, video_list }) {
      let list = [...img_list, ...video_list, ...sound_list];
      this.$materialBox("", null, {
        index: 0,
        list,
        quickEdit: this.$store.state.quickEdit,
        create: this.$store.state.create,
        canEdit: false
      });
    },
    goClue() {
      // 创建线索
      common.jump("/creatClue?t=0", true);
    },
    async goReport(i) {
      const type = await this.$pageType();
      if (!type) return;

      const info = {
        id: i.id,
        type: type
      };
      const newWindow = window.open();

      common.myFetch(apis.clue_toReport, info).then(r => {
        if (r) {
          const reportId = r.report_id;

          newWindow.location.href = `${window.location.origin
            }/creatReport?push=${i.id}&t=${type}&d=${reportId}`;

          // common.jump(`/creatReport?push=${i.id}&t=${type}&d=${reportId}`, true)
        }
      });
    },
    goDetail(i) {
      this.$set(i, "has_change", 0);
      this.$set(i, "is_new", 0);
      common.jump(`/clueDetail?d=${i.id}`, true);
    },
    goRptDtl(r) {
      if (!r.has_report_detail_role) {
        this.$toast("无访问权限");
        return;
      }

      if (r.type == "report") {
        common.jump(`/reportDetail?d=${r.report_id}`, true);
      } else if (r.type == "publish") {
        common.jump(`/publishDetail?d=${r.report_id}`, true);
      } else if (r.type == "material") {
        common.jump(`/clueDetail?d=${r.report_id}`, true);
      } else if (r.type == "new_media") {
        common.jump(`/mediaPublishDetail?d=${r.report_id}`, true);
      }
    },
    fresh() {
      // 无修改刷新列表
      this.$parent.getList();
    },

    imgError(i) {
      // 图片加载状态
      this.$set(i, "img_url", this.defaultImg);
    }
  },
  mounted() {
    this.defaultImg = this.$_syscfg.default_img
  }
};
</script>

<style src='./baseItem.less' lang='less' scoped>
</style>

<style lang="less">
  .filter-container {
    em {
      color: #41b48c!important;
      font-style: normal;
    }
  }
</style>
